<template>
  <div class="header">
    <!-- header-start -->
    <header>
      <div class="header-area">
        <div
          id="sticky-header"
          class="main-header-area"
          :class="{ sticky: isSticky }"
        >
          <div class="container-fluid p-0">
            <div class="row align-items-center no-gutters">
              <div class="col-sm-3 col-xs-3 col-xl-3 col-lg-3">
                <div class="logo-img">
                   <router-link
                          :to="`/${$i18n.locale}`"
                          ><img src="../../img/logo.png" alt="Barbershop Agadir | salon de coiffure Agadir | صالون حلاقة" />
                        </router-link>
            
                </div>
              </div>
              <div class="col-xl-5 col-lg-5">
                <div class="main-menu">
                  <nav>
                    <ul
                      class="mobileMenu"
                      :class="[
                        display ? 'menu-close' : 'menu-open',
                        { mobileDisplay: show },
                      ]"
                    >
                      <li>
                        <router-link
                          @click.native="scrollToTop"
                          :to="`/${$i18n.locale}`"
                          exact
                          >{{ $t("nav.home") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          @click.native="scrollToTop"
                          :to="`/${$i18n.locale}/about`"
                          >{{ $t("nav.about") }}</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          @click.native="scrollToTop"
                          :to="`/${$i18n.locale}/service`"
                          >{{ $t("nav.service") }}</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          @click.native="scrollToTop"
                          :to="`/${$i18n.locale}/gallery`"
                          >{{ $t("nav.gallery") }}</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          @click.native="scrollToTop"
                          :to="`/${$i18n.locale}/contact`"
                          >{{ $t("nav.contact") }}</router-link
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 d-none d-lg-block">
               
                <div class="book_room">
                  <select  @change="setLocale($event)" class="selectpicker" data-width="fit">
                    <option value='fr'>FR</option>
                    <option value='en'>EN</option>
                   </select>
                  <div class="book_btn d-none d-md-none d-lg-block">
                    <a
                      @click="$store.commit('toggleActive')"
                      class="popup-with-form"
                      >{{ $t("nav.appointment") }}</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-xs-3 div-burger">
                 <div class="languge_select" style="position: absolute;right: 40px;">
                   <select  @change="setLocale($event)" class="selectpicker" data-width="fit">
                    <option value='fr'>FR</option>
                    <option value='en'>EN</option>
                   </select>
                </div>
                <div>
                  <span @click="openMenu" 
                    class="menu-burger"
                    :class="{ mobile_menu: !show }"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- header-end -->
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";

export default {
    props:['display'],

  data() {
    return {
      isSticky: false,
      show: true,
      
    };
  },
  computed: {
    ...mapState(["mobile"]),
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    openMenu() {
      this.show = !this.show;
      this.display = !this.display ;
    },
    setLocale(event){
      this.$i18n.locale=event.target.value;
      console.log(event.target.value)
      this.$router.push({
        params:{lang:event.target.value}
      })

    }
  },
  mounted() {
    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();
      if (scroll < 400) {
        $("#sticky-header").removeClass("sticky");
        $("#back-top").fadeIn(500);
      } else {
        $("#sticky-header").addClass("sticky");
        $("#back-top").fadeIn(500);
      }
    });
  },

  
};
</script>
<style>
 .dropdown-toggle{
    background:transparent;
    border-color: transparent;
    color: #ffff;
    font-weight: 600;
  }
     .dropdown-toggle:hover,.dropdown-toggle:focus,.dropdown-toggle:active{
     background: transparent !important;
     color: #ffff !important;
     border-color: transparent !important;
     outline:none !important;
   }
   .bootstrap-select .dropdown-menu li .active {
     background: #422e25;
   }
   .bootstrap-select .dropdown-toggle:focus {
    outline: none !important;
}


</style>

<style lang="scss" scoped>
@import "../../styles/_responsive.scss";
@import "../../styles/_mixins.scss";
@import "../../styles/_varriable.scss";
@import "../../styles/_slick-nav.scss";
@import "../../styles/pages/_header.scss";
  .dropdown{
   background: transparent !important;
   color: #ffff !important;

  }

 


.div-burger {
  float: right;
  right: 0;
  position: absolute;
  right: 20px;
  width: 52px;
  height: 42px;
  cursor: pointer;
  .menu-burger {
    background: $white_color;
    width: 33px;
    height: 3px;
    float: right;
    right: 0;
    margin-top: 17px;
    cursor: pointer;
    &:before {
      content: "";
      margin-top: -10px;
      position: absolute;
      background: $white_color;
      width: 33px;
      height: 3px;
      float: right;
      right: 0;
    }
    &:after {
      content: "";
      margin-top: 10px;
      position: absolute;
      background: $white_color;
      width: 33px;
      height: 3px;
      float: right;
      right: 0;
    }
  }
  @media #{$big_device} {
    display: none !important;
  }
}

</style>
